import deckmapp from './deckmapp/texts.js';
import favourites from './favourites/texts.js';
import feedback from './feedback/text.js';
import timeZone from './timezone/texts.js';

export default {
  deckmapp,
  favourites,
  feedback,
  timeZone,
};
